import React, { memo } from 'react'
import { Col } from 'react-bootstrap'
import { AuctionCreditBalanceCardModule } from '../../../../modules/AuctionCreditBalanceCard'
import { AuctionMonthlyBudgetCardModule } from '../../../../modules/AuctionMonthlyBudgetCard'
import { AuctionCampaignStatusCardModule } from '../../../../modules/AuctionCampaignStatusCard'
import { targets } from '../../../../contexts/utils/config.joyride'

const HTR_PUBLISHER_ID = 67

const TopCards = ({ publisherIdByAbbr, campaign, campaignCategories, currentSkin, anyActiveSpecificBid, anyActiveBrandingBid, anyActiveClusterBid, anyActiveEmailsBid, budgetLoading, handleShowBottom, days_diff, handleCampaignActivate, updateBudget }) => {
  const mdSize = HTR_PUBLISHER_ID == publisherIdByAbbr ? "4" : "6"
  return (
    <>
      <Col md={HTR_PUBLISHER_ID == publisherIdByAbbr ? "4" : "12"} xl="4">
        <AuctionCampaignStatusCardModule
          publisher_id={publisherIdByAbbr}
          campaign={campaign}
          campaignCategories={campaignCategories}
          currentSkin={currentSkin}
          anyActiveSpecificBid={anyActiveSpecificBid}
          anyActiveBrandingBid={anyActiveBrandingBid}
          anyActiveClusterBid={anyActiveClusterBid}
          anyActiveEmailsBid={anyActiveEmailsBid}
          id={targets.ppcSummaryBarStatus}
        />
      </Col>
      <Col md={mdSize} xl="4">
        <AuctionCreditBalanceCardModule
          publisher_id={publisherIdByAbbr}
          campaign={campaign}
          id={targets.ppcSummaryBarCredits}
        />
      </Col>
      <Col md={mdSize} xl="4">
        <AuctionMonthlyBudgetCardModule
          publisher_id={publisherIdByAbbr}
          campaign={campaign}
          budgetLoading={budgetLoading}
          handleShowBottom={handleShowBottom}
          days_diff={days_diff}
          handleCampaignActivate={handleCampaignActivate}
          id={targets.ppcSummaryBarBudget}
        />
      </Col>
    </>
  )
}

export default memo(TopCards)
